import { render } from 'preact-render-to-string';
import { BasicEmailWrapper, Line, Link, SupportFooter, replacePlaceholders } from './shared';
import { esc } from 'shared/htm';
import * as fmt from 'shared/payments/fmt';
import { Currency } from 'server/types';

export type TrialReminderProps = {
  firstName: string;
  daysRemaining: number;
  billingAmount: string;
  firstChargeDate: string;
  cancelUrl: string;
  supportEmail: string;
};

function Signature() {
  return (
    <Line>
      Danny Iny
      <br />
      Founder/CEO at Mirasee
    </Line>
  );
}

// The first reminder. Was sent at 14 days until 2026-10-05.
function Email12d(opts: BodyProps) {
  return (
    <>
      <Line>Hey {opts.firstName},</Line>
      <Line>
        To help you grow your business even more this year, we're cooking up some awesome resources
        for you inside AI Playground…
      </Line>
      <Line>With AI Playground, you have access to a bounty of amazing resources including…</Line>
      <Line>
        …a library of deep dive trainings about different facets of online course marketing…
      </Line>
      <Line>
        …a vibrant, generous community of entrepreneurs eager to support your growth and celebrate
        your wins…
      </Line>
      <Line>
        …regular support from Ari, our VP of Growth and the Mirasee team to keep your progress
        strong...
      </Line>
      <Line>
        …live courses you can join that would ordinarily cost hundreds or thousands of dollars… and
        that's all included in your membership!
      </Line>
      <Line>
        Keep in mind, your free membership trial period is coming to a close on{' '}
        <strong>{opts.firstChargeDate}</strong>. And the good news is…
      </Line>
      <Line>
        …to continue with AI Playground and enjoy all the benefits and resources you've come to know
        and love, you don't have to lift a finger!
      </Line>
      <Line>
        As we explained when you signed up, going forward, you'll automatically be charged a monthly
        membership fee. You'll see a charge of {opts.billingAmount} on your bank statement on{' '}
        {opts.firstChargeDate} each month.
      </Line>
      <Line>
        You may cancel your membership at any time in the future (note there are no refunds). Or if
        for any reason you don't wish to stay in AI Playground, just{' '}
        <Link href={opts.cancelUrl}>follow this link to cancel your membership</Link> and you won't
        be charged a thing.
      </Line>
      <Line>
        Thank you again for being a member in our AI Playground community, {opts.firstName}. I can't
        wait to see what you achieve in the year ahead!
      </Line>
      <Signature />
    </>
  );
}

function Email7d(opts: BodyProps) {
  return (
    <>
      <Line>Hey {opts.firstName},</Line>
      <Line>
        Back in 2011 when I first set out to sell an online course, I had ZERO experience doing
        business online. At the time, I worked with all my consulting clients in person.
      </Line>
      <Line>
        Needless to say, I had a lot to learn about pretty much everything – including course
        design, my ideal customer avatar, technology, marketing – and made a lot of mistakes along
        the way.
      </Line>
      <Line>
        It would've been so much easier and faster to grow Mirasee if I'd had the expert guidance,
        premium resources, and an inspiring community like you have inside our AI Playground…
      </Line>
      <Line>
        …and that's what you'll continue to have even though your free trial membership is coming to
        an end!
      </Line>
      <Line>
        As we mentioned when you signed up, once your free trial period ends, you'll be
        automatically charged {opts.billingAmount} each month, starting on{' '}
        <strong>{opts.firstChargeDate}</strong>.
      </Line>
      <Line>
        Keep in mind, you may cancel your membership at any time in the future (note there are no
        refunds). Or if for any reason you don't wish to stay in AI Playground, just{' '}
        <Link href={opts.cancelUrl}>follow this link to cancel your membership</Link> and you won't
        be charged a thing.
      </Line>
      <Line>
        But I really hope you continue with us because we have some very exciting resources coming
        your way.
      </Line>
      <Line>
        One of the best things about AI Playground is, you also get the guidance and feedback you
        need, so you can skip the mistakes and move straight ahead to growing every aspect of your
        business!
      </Line>
      <Line>Plus, you get a bounty of other benefits with your membership such as…</Line>
      <Line>
        …live courses you can join that would ordinarily cost hundreds or thousands of dollars…
      </Line>
      <Line>
        …a library of deep dive trainings about different facets of online course marketing…
      </Line>
      <Line>
        …a vibrant, generous community of entrepreneurs eager to support your growth and celebrate
        your wins…
      </Line>
      <Line>
        …regular support from Ari, our VP of Growth and the Mirasee team, to keep your progress
        strong…
      </Line>
      <Line>...and much more!</Line>
      <Line>
        With everything you get with your AI Playground membership, your business can't help but hit
        exciting new heights this year, {opts.firstName}. And my team and I will be here to make the
        experience as fun and rewarding as possible. ;)
      </Line>
      <Signature />
    </>
  );
}

function Email4d(opts: BodyProps) {
  return (
    <>
      <Line>Hey {opts.firstName},</Line>
      <Line>Have you heard of the concept 'narrow focus'?</Line>
      <Line>
        It's all about doing what only you can do for your business, and making it better every day.
      </Line>
      <Line>For example…</Line>
      <Line>
        …it shouldn't be your job to read 5 books about email list engagement and then pick and
        choose the best practices…
      </Line>
      <Line>
        …it shouldn't be your job to test half a dozen marketing tactics and hope one of them works…
      </Line>
      <Line>
        …it shouldn't be your job to test drive a bunch of groups and forums until you find one that
        helps you thrive...
      </Line>
      <Line>
        It's your job to be an expert at what you do and love best, and deliver that to people who
        will happily pay you for your results.
      </Line>
      <Line>And that's what's so awesome about your AI Playground Membership!</Line>
      <Line>
        Instead of trying to figure out on your own what will work best, we've done all the heavy
        lifting for you.
      </Line>
      {/* <strong> rather than font-weight so the heading stays bold in the editable copy. */}
      <Line style="margin-top:1.5rem;margin-bottom:0.5rem;">
        <strong>One More Thing</strong>
      </Line>
      <Line>
        The free trial portion of your membership is coming to an end on{' '}
        <strong>{opts.firstChargeDate}</strong>. But you have nothing to worry about, because your
        membership will continue without a blink. ;-)
      </Line>
      <Line>
        On {opts.firstChargeDate}, you'll see your first monthly payment of just{' '}
        {opts.billingAmount}.
      </Line>
      <Line>
        Keep in mind, you may cancel your membership at any time in the future (note there are no
        refunds). Or if for any reason you don't wish to stay in AI Playground, just{' '}
        <Link href={opts.cancelUrl}>follow this link to cancel your membership</Link> and you won't
        be charged a thing.
      </Line>
      <Line>
        With everything you get inside AI Playground, you can focus on what you do and love best,{' '}
        {opts.firstName}... which is a great way to grow the profitable, impactful business you
        dream of.
      </Line>
      <Line>So excited for you. :-)</Line>
      <Signature />
    </>
  );
}

type BodyProps = Omit<TrialReminderProps, 'daysRemaining' | 'supportEmail'>;

function BuiltInBody(opts: BodyProps & { daysRemaining: number }) {
  switch (opts.daysRemaining) {
    case 7:
      return <Email7d {...opts} />;
    case 4:
      return <Email4d {...opts} />;
    default:
      return <Email12d {...opts} />;
  }
}

/**
 * An admin-edited version of a reminder, from trial_reminder_templates.
 * Sanitized when saved; fill-in fields are substituted at send time.
 */
export type TrialReminderOverride = { subject: string; bodyHtml: string };

/** Fill-in fields an edited reminder can use, as {{{name}}}. */
export const TRIAL_REMINDER_FIELDS = {
  'first-name': "The member's first name",
  'first-charge-date': 'Date of their first payment, e.g. October 19, 2026',
  'billing-amount': 'What they will be charged each month, e.g. US$97',
} as const;

export type TrialReminderField = keyof typeof TRIAL_REMINDER_FIELDS;

/** Fill-in field names used in `s` that aren't in TRIAL_REMINDER_FIELDS. */
export function unknownTrialReminderFields(s: string) {
  const names = [...s.matchAll(/{{{([^}]+)}}}/g)].map((m) => m[1].trim());
  return [...new Set(names.filter((n) => !(n in TRIAL_REMINDER_FIELDS)))];
}

function fieldValues(opts: TrialReminderProps): Record<TrialReminderField, string> {
  return {
    'first-name': opts.firstName,
    'first-charge-date': opts.firstChargeDate,
    'billing-amount': opts.billingAmount,
  };
}

export function TrialReminderEmail(opts: TrialReminderProps, override?: TrialReminderOverride) {
  const footer = <SupportFooter email={opts.supportEmail} />;
  if (!override) {
    return render(
      <BasicEmailWrapper footer={footer}>
        <BuiltInBody {...opts} />
      </BasicEmailWrapper>,
    );
  }
  // The shared email stylesheet zeroes paragraph margins, so give unstyled
  // paragraphs the same spacing <Line> gives the built-in copy.
  const bodyHtml = override.bodyHtml.replace(
    /<p(?![^>]*\sstyle=)([^>]*)>/g,
    '<p style="margin-bottom:1rem;"$1>',
  );
  const html = render(
    <BasicEmailWrapper footer={footer}>
      <div dangerouslySetInnerHTML={{ __html: bodyHtml }}></div>
    </BasicEmailWrapper>,
  );
  return replacePlaceholders(html, fieldValues(opts), (s) => esc(s ?? ''));
}

/**
 * The built-in copy as editable HTML, with fill-in fields in place of the
 * member's details. This is what the editor starts from before anyone has
 * saved a version. The cancel link is a real URL rather than a field because
 * the sanitizer drops a link whose address isn't a URL.
 */
export function defaultTrialReminderBodyHtml(daysRemaining: number, cancelUrl: string) {
  // Inline styles and link targets are stripped: the rich editor can't keep
  // them, and a body that has them opens as a raw HTML box instead
  // (needsHtmlSource in client/components/minidoc/html-content.ts).
  return render(
    <BuiltInBody
      daysRemaining={daysRemaining}
      firstName="{{{first-name}}}"
      firstChargeDate="{{{first-charge-date}}}"
      billingAmount="{{{billing-amount}}}"
      cancelUrl={cancelUrl}
    />,
  ).replace(/\s(?:style|target|rel)="[^"]*"/g, '');
}

export function defaultTrialReminderSubject(daysRemaining: number) {
  return trialReminderSubject(daysRemaining, '{{{first-name}}}');
}

export function renderTrialReminderSubject(
  opts: TrialReminderProps,
  override?: TrialReminderOverride,
) {
  if (!override) {
    return trialReminderSubject(opts.daysRemaining, opts.firstName);
  }
  return replacePlaceholders(override.subject, fieldValues(opts), (s) => s ?? '');
}

export function trialReminderSubject(daysRemaining: number, firstName: string) {
  switch (daysRemaining) {
    case 12:
      return '[AI Playground] Your membership renewal [Important]';
    case 7:
      return '[AI Playground] Your membership renewal and fee';
    case 4:
      return `[AI Playground] 4 days 'til your membership fee kicks in, ${firstName}`;
    default:
      return '[AI Playground] Your membership renewal [Important]';
  }
}

export function formatBillingInterval(interval?: string) {
  switch (interval) {
    case 'month':
      return 'month';
    case 'year':
      return 'year';
    case 'week':
      return 'week';
    case 'day':
      return 'day';
    default:
      return 'month';
  }
}

export function formatBillingAmount(priceInCents: number, currency: Currency) {
  return fmt.price({ priceInCents, currency });
}
